/**
 * GS-5/5b/6 — unified group-card HTTP via groups/v1 contract paths.
 */

import {
  buildDeleteGroupsV1Path,
  buildGetGroupsV1SettingsPath,
  buildPostGroupsV1ApplyPath,
  buildPutGroupsV1SettingsPath,
} from "./group-console-api.js";

/** @type {((path: string, opts?: object) => Promise<unknown>) | null} */
let _api = null;

/**
 * @param {(path: string, opts?: object) => Promise<unknown>} apiFn
 */
export function bindGroupCardsApi(apiFn) {
  _api = apiFn;
}

function _requireApi() {
  if (!_api) throw new Error("group-cards-v1: call bindGroupCardsApi(api) first");
  return _api;
}

/**
 * @param {{ group_key: string, owner_admin?: string, timeoutMs?: number }} opts
 */
export async function getGroupCardSettingsV1(opts) {
  const gk = String(opts.group_key || "").trim();
  if (!gk) throw new Error("group_key required");
  return _requireApi()(buildGetGroupsV1SettingsPath(gk, opts.owner_admin), {
    method: "GET",
    timeoutMs: opts.timeoutMs != null ? opts.timeoutMs : 16000,
  });
}

/**
 * @param {{ group_key: string, owner_admin?: string, body: object, timeoutMs?: number }} opts
 */
export async function putGroupCardSettingsV1(opts) {
  const gk = String(opts.group_key || "").trim();
  if (!gk) throw new Error("group_key required");
  const body = Object.assign({}, opts.body || {});
  const oa = String(opts.owner_admin || "").trim();
  if (oa) body.owner_admin = oa;
  return _requireApi()(buildPutGroupsV1SettingsPath(gk, opts.owner_admin), {
    method: "PUT",
    body,
    timeoutMs: opts.timeoutMs != null ? opts.timeoutMs : 20000,
  });
}

/**
 * @param {{ group_key: string, owner_admin?: string, timeoutMs?: number }} opts
 */
export async function applyGroupCardSettingsV1(opts) {
  const gk = String(opts.group_key || "").trim();
  if (!gk) throw new Error("group_key required");
  return _requireApi()(buildPostGroupsV1ApplyPath(gk, opts.owner_admin), {
    method: "POST",
    timeoutMs: opts.timeoutMs != null ? opts.timeoutMs : 45000,
  });
}

export async function deleteGroupCardV1(opts) {
  const gk = String(opts.group_key || "").trim();
  if (!gk) throw new Error("group_key required");
  return _requireApi()(buildDeleteGroupsV1Path(gk, opts.owner_admin), {
    method: "DELETE",
    timeoutMs: opts.timeoutMs != null ? opts.timeoutMs : 20000,
  });
}
